import { resolveAdminApiUrl } from '../../../Api/apiUrl';
import { invoiceLogger } from './invoiceLogger';

const ADMIN_API_URL = resolveAdminApiUrl(process.env.REACT_APP_API_URL);
const TELEMETRY_ENDPOINT = `${ADMIN_API_URL}/invoices/settlement-breakdown-telemetry/events`;

export type SettlementBreakdownTelemetryEventType =
  | 'legacy_fallback_applied'
  | 'non_legacy_missing_breakdown_blocked'
  | 'legacy_missing_breakdown_with_history_blocked'
  | 'partial_breakdown_blocked';

export interface SettlementBreakdownTelemetryPayload {
  eventType: SettlementBreakdownTelemetryEventType;
  invoiceId?: number;
  invoiceNumber?: string;
  isLegacySettlementRecord?: boolean;
  hasPaymentHistory?: boolean;
  missingFields?: string[];
}

const getAuthToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem('authToken');
};

export const emitSettlementBreakdownTelemetry = (
  payload: SettlementBreakdownTelemetryPayload
): void => {
  if (typeof fetch !== 'function') {
    return;
  }

  const authToken = getAuthToken();
  if (!authToken) {
    return;
  }

  const requestBody = {
    eventType: payload.eventType,
    invoiceId: payload.invoiceId,
    invoiceNumber: payload.invoiceNumber,
    isLegacySettlementRecord: payload.isLegacySettlementRecord,
    hasPaymentHistory: payload.hasPaymentHistory,
    missingFields: payload.missingFields ?? [],
    observedAtUtc: new Date().toISOString(),
  };

  void fetch(TELEMETRY_ENDPOINT, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      accept: 'application/json',
      authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(requestBody),
    keepalive: true,
  })
    .then((response) => {
      if (!response.ok) {
        invoiceLogger.warn('[Invoices] Settlement breakdown telemetry rejected by API', {
          status: response.status,
          eventType: payload.eventType,
          invoiceId: payload.invoiceId,
        });
      }
    })
    .catch((error: unknown) => {
      invoiceLogger.warn('[Invoices] Settlement breakdown telemetry send failed', {
        eventType: payload.eventType,
        invoiceId: payload.invoiceId,
        error,
      });
    });
};
